import axios from "../config/axios";
import queryString from "query-string";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../config/toastNotification";

export const loadItemsGeneral = async (dispatch, url, search) => {
  dispatch({
    type: "FETCH_REQUEST",
  });

  try {
    const res = await axios.get(`${url}${search}`); //
    dispatch({
      type: "FETCH_SUCCESS",
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: "FETCH_FAILURE",
      payload: error,
    });
  }
};

export const setFilterGeneral = (
  name,
  value,
  appliedFilters,
  setAppliedFilters,
  history
) => {
  //console.log(`setFilter called with ${name}, ${value}`);
  let newAppliedFilters = JSON.parse(JSON.stringify(appliedFilters));

  if (value) {
    newAppliedFilters[name] = value;
  } else {
    delete newAppliedFilters[name];
  }

  if (name !== "page") {
    delete newAppliedFilters["page"];
  }

  let newURL = queryString.stringify(newAppliedFilters);
  history({ search: newURL });
  setAppliedFilters(newAppliedFilters);
};

export const resetFiltersGeneral = (
  appliedFilters,
  setAppliedFilters,
  history,
  moduleConfig
) => {
  //console.log(`resetFilters called`)
  let newAppliedFilters = JSON.parse(JSON.stringify(appliedFilters));

  moduleConfig.perPageItems = 10;
  delete newAppliedFilters["limit"];
  delete newAppliedFilters["status"];
    delete newAppliedFilters["to"];
  delete newAppliedFilters["showOnHomePage"];
  delete newAppliedFilters["source"];
  delete newAppliedFilters["year"];
  delete newAppliedFilters["vegOrNonVeg"];
  delete newAppliedFilters["hotOrCold"];
  delete newAppliedFilters["inStock"];
  delete newAppliedFilters["categories[]"];
  delete newAppliedFilters["materials[]"];
  delete newAppliedFilters["allergens[]"];
  delete newAppliedFilters["foodTime"];
  delete newAppliedFilters["has"];
  delete newAppliedFilters["orderStatus"];
  delete newAppliedFilters["checkoutType"];
  delete newAppliedFilters["paymentStatus"];
  delete newAppliedFilters["paymentFailed"];
  delete newAppliedFilters["importance"];
  delete newAppliedFilters["source"];
  delete newAppliedFilters["q"];

  let newURL = queryString.stringify(newAppliedFilters);
  history({ search: newURL });
  //console.log(newAppliedFilters);
  setAppliedFilters(newAppliedFilters);
};

export const confirmAndDisabledGeneral = async (
  id,
  apiURL,
  confirm,
  dispatch
) => {
  const isConfirmed = await confirm(`Do you really want to disable this item?`);

  if (isConfirmed) {
    return await changeStatus(id, false, apiURL, dispatch);
  }
};

export const confirmAndEnabledGeneral = async (
  id,
  apiURL,
  confirm,
  dispatch
) => {
  const isConfirmed = await confirm(`Do you really want to enable this item?`);

  if (isConfirmed) {
    return await changeStatus(id, true, apiURL, dispatch);
  }
};

export const onSubmitGeneral = async (
  data,
  apiURL,
  afterSubmissionURL,
  dispatch,
  navigate
) => {
  dispatch({
    type: "FORM_SUBMISSION_REQUEST",
  });

  try {
    const res = await axios.post(`${apiURL}`, data); //
    dispatch({
      type: "FORM_SUBMISSION_SUCCESS",
      payload: res.data,
    });
    if (afterSubmissionURL === "back") {
      navigate(-1);
    } else {
      navigate(`/${afterSubmissionURL}`);
    }

    toast.addNotification({
      ...toastNotification,
      title: "Success!",
      message: `Action performed successfully.`,
      type: "success",
    });
  } catch (error) {
    const status = error.response ? error.response.status : 500;
    const errorMessage =
      status === 400 ? error.response.data.message : error.message;
    dispatch({
      type: "FORM_SUBMISSION_FAILURE",
      payload: errorMessage,
    });
    setTimeout(() => {
      dispatch({
        type: "FORM_INITIAL_STATE",
      });
    }, 5000);
  }
};

export const loadItemGeneral = async (id, apiURL, dispatch) => {
  if (id) {
    dispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.get(apiURL); //
      dispatch({
        type: "FETCH_SUCCESS",
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    }
  }
};
export const loadItemGeneralPost = async (id, apiURL, dispatch, data) => {
  if (id) {
    dispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.post(apiURL, data); //
      dispatch({
        type: "FETCH_SUCCESS",
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    }
  }
};
const changeStatus = async (id, undo, apiURL, dispatch) => {
  //console.log("In block Item Function");
  dispatch({
    type: "BLOCK_REQUEST",
  });

  try {
    const res = await axios.post(apiURL, {
      id,
      status: undo === true ? "1" : "0",
    });
    //loadItemsGeneral();
    // dispatch({
    //     type: "DELETE_SUCCESS"
    // });
    toast.addNotification({
      ...toastNotification,
      title: "Success!",
      message: `Item ${undo ? "enabled" : "disabled"} successfully.`,
      type: "success",
    });
    return true;
  } catch (error) {
    dispatch({
      type: "BLOCK_FAILURE",
      payload: error,
    });
    setTimeout(() => {
      dispatch({
        type: "REMOVE_ERROR",
      });
    }, 5000);
    return false;
  }
};

export const loadDataForCreateItemGeneral = async (apiURL, dispatch) => {
  dispatch({
    type: "FETCH_REQUEST",
  });

  try {
    const res = await axios.get(apiURL); //
    dispatch({
      type: "FETCH_SUCCESS",
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: "FETCH_FAILURE",
      payload: error,
    });
  }
};

export const confirmAndDeleteGeneral = async (
  id,
  apiURL,
  confirm,
  dispatch
) => {
  const isConfirmed = await confirm(`Do you really want to delete this item?`);

  if (isConfirmed) {
    return await deleteItem(id, apiURL, dispatch);
  }
};

const deleteItem = async (id, apiURL, dispatch) => {
  dispatch({
    type: "DELETE_REQUEST",
  });
  try {
    const res = await axios.delete(apiURL);

    toast.addNotification({
      ...toastNotification,
      title: "Success!",
      message: `Item deleted successfully.`,
      type: "success",
    });
    return true;
  } catch (error) {
    dispatch({
      type: "DELETE_FAILURE",
      payload: error,
    });

    setTimeout(() => {
      dispatch({
        type: "REMOVE_ERROR",
      });
    }, 5000);
    return false;
  }
};
